/** Los dos módulos de negocio de la plataforma Jamar (gateway de entrada). */
export type IdModulo = 'feria' | 'calidad'

export interface OpcionModulo {
  id: IdModulo
  titulo: string
  descripcion: string
  acento: string
  /** Ruta de login propia de ese módulo — Feria reutiliza el login real existente. */
  rutaLogin: string
  /** A dónde entrar directo si ya hay sesión activa. */
  rutaDestino: string
}

export const MODULOS: OpcionModulo[] = [
  {
    id: 'feria',
    titulo: 'Feria',
    descripcion: 'Gestiona tu participación, proveedores y actividades de la feria.',
    acento: '#FF0600',
    rutaLogin: '/login',
    rutaDestino: '/dashboard',
  },
  {
    id: 'calidad',
    titulo: 'Calidad',
    descripcion: 'Inspección, control y gestión de calidad de la feria.',
    acento: '#00A8FF',
    rutaLogin: '/calidad/login',
    rutaDestino: '/calidad',
  },
]

/** Recordamos qué módulo se eligió para, si ya hay sesión al volver, saltar directo sin preguntar de nuevo. */
export const CLAVE_ULTIMO_MODULO = 'feria-china-2026:ultimo-modulo'
